module.exports = __webpack_public_path__ + "img/EA120.aeb65244.png";